
const getColors = client => {
  return {
    primaryColor: 'rgb(69,122,189)',
    primary2Color: '#666',
    complementaryColor: '#fff',
    labelColor: 'rgba(0,0,0,0.3)',
  };
};

const TOKEN_IDENTIFIER = '@WISBI:authToken';

const getConfig = () => ({
  apiUrl: process.env.REACT_APP_API_URL,
  thumbBaseUrl: 'https://res.cloudinary.com/arkulpa/image/upload/c_limit,h_100,w_150/',
  getAuthHeader() {
    const authToken = localStorage.getItem(TOKEN_IDENTIFIER);
    return authToken ? `Bearer ${authToken}` : null;
  },
  getAuthToken() {
    return localStorage.getItem(TOKEN_IDENTIFIER);
  },
  removeAuthToken() {
    localStorage.removeItem(TOKEN_IDENTIFIER);
  },
  writeAuthToken(token) {
    localStorage.setItem(TOKEN_IDENTIFIER, token);
  },
  colors: getColors(),
  minutesStep: 5,
  showRegister: false,
  showLoginLogo: true,
});
export default getConfig();



// WEBPACK FOOTER //
// ./src/config.js